/*
 * Purpose: Zod schema for L1 outcome interpretation (before full plan)
 * Last modified: 2026-06-27 | Agent
 * Completeness: 95
 */
import { z } from 'zod';

export const intentInterpretationSchema = z.object({
  interpretedGoal: z.string().min(1),
  confidence: z.number().min(0).max(1),
  suggestedComposeMode: z.enum(['express', 'guided']).optional(),
  assumptions: z.array(z.string()).default([]),
  gaps: z.array(z.string()).default([]),
  needsGmail: z.boolean().optional(),
  needsLinkedIn: z.boolean().optional(),
  needsOpenAi: z.boolean().optional(),
  matchedTemplateHint: z.string().optional(),
});

export type IntentInterpretationPayload = z.infer<typeof intentInterpretationSchema>;
